let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9dEqa")).then(() => parcelRequire('7S4i0'));